<template>
  <v-progress-circular
    v-if="spinn"
    :width="3"
    color="primary"
    indeterminate
  ></v-progress-circular>
  <v-card v-else>
    <v-card-title>
      <v-text-field
        class="w-100"
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
      <v-btn @click="downloadExcel()" class="excel-btn">
        <v-icon> mdi-file-excel </v-icon><span>Descargar</span>
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="filteredData"
      :search="search"
    ></v-data-table>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-card>
</template>

<script>
import * as XLSX from "xlsx";
import store from "@/store/index";
import { getMethodToken, postMethodToken } from "@/api-consume/api-calls";

export default {
  data() {
    return {
      spinn: true,
      snackbar: false,
      snackbarText: "",
      snackbarTimeout: 3000,
      snackbarColor: "",
      search: "",
      headers: [],
      data: []
    };
  },
  async created() {
    await this.getList();
  },
  computed: {
    filteredData() {
      let obj = this.data;

      //Aplicamos la búsqueda
      if (this.search != "") {
        obj = obj.filter(item =>
          Object.keys(item).some(
            index =>
              item[index] != null &&
              item[index]
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase())
          )
        );
      }

      return obj;
    }
  },
  methods: {
    async getList() {
      this.spinn = true;
      const response = await getMethodToken(
        "/api/appraisals/list/all-complete"
      );
      console.log("LISTA TASACIONES COMPLETA: ", response);
      if (response.status == 200 && response.data.payload) {
        let data = response.data.payload;
        this.headers = Object.keys(data.headers).map(key => {
          return { text: data.headers[key], value: key };
        });
        this.data = data.appraisals;
        this.spinn = false;
      } else {
        this.snackbar = true;
        this.snackbarText = response.data.message;
        this.snackbarColor = "red";
        this.spinn = false;
      }
    },
    async downloadExcel() {
      try {
        const formData = new FormData();
        formData.append("file", this.filteredData);
        formData.append("user", store.state.userLogged.user_id);

        const response = await postMethodToken("/api/send-data", formData);
        console.log("Respuesta SENDDATA: ", response);

        if (response.status === 200) {
          this.snackbar = true;
          this.snackbarText = "Fichero generado con éxito. Revisa tu email.";
          this.snackbarColor = "green";

          // Crear una hoja de cálculo con los datos
          const ws = XLSX.utils.json_to_sheet(this.filteredData);

          // Agregar las cabeceras a la hoja de cálculo
          XLSX.utils.sheet_add_json(ws, this.filteredData, {
            skipHeader: true,
            origin: "A2"
          });

          // Crear un libro de Excel y agregar la hoja de cálculo
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Data");

          // Generar el archivo Excel
          XLSX.writeFile(wb, "data.xlsx");
        } else {
          this.snackbar = true;
          this.snackbarText = "Error al subir el archivo al servidor";
          this.snackbarColor = "red";
        }
      } catch (error) {
        console.error("Error al subir el archivo:", error);
        this.snackbar = true;
        this.snackbarText = "Error al subir el archivo al servidor";
        this.snackbarColor = "red";
      }
    }
  }
};
</script>

<style>
.excel-btn {
  margin-left: 20px;
}

@media only screen and (max-width: 480px) {
  .excel-btn {
    margin-left: 0px;
    margin-top: 20px;
  }
}
</style>
